import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireDatabase } from 'angularfire2/database';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/filter';

@Injectable()

export class ServiciosService {

  // Representación de un día en milisegundos
  private diasEnMilis:number = 1000 * 60 * 60 * 24;

  constructor(private afs:AngularFirestore, private afDB:AngularFireDatabase,private http:HttpClient) { }


  public getServiciosEnRango(fromMs: number, toMs: number, zona?: string): Observable<any[]> {
    // To capture services that start, end, or span the date range, we need to:
    // 1. Query services that could potentially overlap (with a buffer for long-running services)
    // 2. Filter in memory for services where finDeServicio >= fromMs
    // This is necessary because Firestore doesn't allow range queries on multiple fields

    const bufferDays = 30;
    const bufferMs = bufferDays * 24 * 60 * 60 * 1000;
    const queryFromMs = fromMs - bufferMs;

    let ref = this.afs.collection('servicios', q => {
      let r = q.where('inicioDeServicio', '>=', queryFromMs)
               .where('inicioDeServicio', '<=', toMs);
      return r;
    });

    return ref.snapshotChanges()
      .filter(snaps => {
        // Skip stale cache emissions — wait for server data
        if (snaps.length === 0) return true;
        return !snaps[0].payload.doc.metadata.fromCache;
      })
      .map(snaps => {
        const allServices = snaps.map(s => ({ $key: s.payload.doc.id, ...s.payload.doc.data() }));

        const filteredServices = allServices.filter((servicio: any) => {
          const finDeServicio = servicio.finDeServicio || servicio.inicioDeServicio;
          return finDeServicio >= fromMs;
        });

        console.log(`[getServiciosEnRango] raw=${allServices.length}, filtered=${filteredServices.length}, range=${new Date(fromMs).toISOString()} - ${new Date(toMs).toISOString()}`);
        return filteredServices;
      });
  }

  /**
   * Genera un objeto de servicio de tipo Posible
   * @param cotizacion Objeto completo de cotización
   * @param idServicio id del servicio al cual se va a
   * @param combinaciones Objeto con las combinaciones seleccionadas por servicio
   */
  public configurarServicioPosbile(cotizacion:any, idServicio:string, combinaciones:any, usuario):any{
    // Almacena el id de la combinacion para usarla después más fácilmente
    let idCombinacion = combinaciones[idServicio];
    // Almacena el servicio
    let servicio = cotizacion.servicios[idServicio];

    // Configura el objeto de servicio que se va a crear
    let objServicioPosible = {
      aliasOrigen : cotizacion.aliasOrigen,
      aliasDestino : cotizacion.aliasDestino,
      cantidadDeOperadores : servicio.parametros.cantidadDeOperadores,
      cantidadDePasajeros : servicio.parametros.cantidadDePasajeros,
      cotizacion : cotizacion.$key,
      idCotizacion : cotizacion.idTrosten,
      cliente : cotizacion.cliente,
      destino : servicio.destino,
      estatus : 'Posible',
      inicioDeServicio : servicio.itinerario.inicioDeServicio,
      finDeServicio : servicio.itinerario.finDeServicio,
      kilometrosDeEstadia : servicio.parametros.kilometrosDeEstadia,
      nochesDeHospedaje : servicio.parametros.nochesDeHospedaje,
      oficinaDeOrigen : servicio.oficinaDeOrigen,
      origen : servicio.origen,
      servicio : idServicio,
      tipoDeVenta : cotizacion.tipoDeVenta,
      tipoDeViaje : servicio.tipoDeViaje,
      usuarioQueConfirmo : usuario,
      unidadesSolicitadas : {},
      verificacionVentas : false,
      verificacionOperaciones : false,
      verificacionOperacionesAt : null
    };

    // Checa si el itinerario tiene llegada a destino y regreso a origen
    if(servicio.itinerario.hasOwnProperty('llegadaADestino'))
      objServicioPosible['llegadaADestino'] = servicio.itinerario.llegadaADestino;
    if(servicio.itinerario.hasOwnProperty('regresoAOrigen'))
      objServicioPosible['regresoAOrigen'] = servicio.itinerario.regresoAOrigen;

    // Agregar al servicio si tiene contacto que cotizó
    if(cotizacion.hasOwnProperty('contactoQueCotizo'))
      objServicioPosible['contactoQueCotizo'] = cotizacion.contactoQueCotizo;
    // Agrega notas si las tiene
    if(servicio.hasOwnProperty('notas'))
      objServicioPosible['notas'] = servicio.notas;
    // Agrega indicaciones especiales si las tiene
    if(servicio.hasOwnProperty('indicacionesEspeciales'))
      objServicioPosible['indicacionesEspeciales'] = servicio.indicacionesEspeciales;
    if(servicio.hasOwnProperty('notasOperaciones'))
      objServicioPosible['notasOperaciones'] = servicio.notasOperaciones;
    // Agrega los conceptos adicionales si los tiene
    if(servicio.hasOwnProperty('puntosIntermedios'))
        objServicioPosible['puntosIntermedios'] = servicio.puntosIntermedios;
    // Aregalos conceptos adicionales, si los tiene
    if(servicio.hasOwnProperty('conceptosAdicionales')){
        let conceptosAdicionales = {};
        for(let conceptoId in servicio.conceptosAdicionales){
          conceptosAdicionales[conceptoId] = servicio.conceptosAdicionales[conceptoId].descripcion;
        }
        objServicioPosible['conceptosAdicionales'] = conceptosAdicionales;
    }
    // Agrega las unidades solicitadas
    for(let idUnidad in servicio.costoCombinaciones[idCombinacion]){
        objServicioPosible.unidadesSolicitadas[idUnidad] = servicio.costoCombinaciones[idCombinacion][idUnidad].numeroDeUnidades;
    }
    return objServicioPosible;
  }

    /**
     * Genera un objeto de servicios listos para poder ser añadidos a una cotizacion
     * @param servicios
     */
    public configurarServiciosParaCreacion(servicios:Array<any>):any {
        // Objeto a regresar de la funcion
        let objServicios = {};

        // Realiza un barrido por los servicios para configurarlos
        servicios.forEach(servicio => {
            // Genera el id de FB del servicio
            let idFirebaseServicio = this.afDB.createPushId();

            // Elimina la propedad de "Numero de Servicio"
            delete servicio['numeroDeServicio'];

            // Si es un viaje sencillo, arregla el nodo de fin de servicio para que cuadre con un viaje redondo
            debugger
            if(servicio['tipoDeViaje'] == 'Viaje Sencillo')
            {
                if(servicio['itinerario']['llegadaADestino'])
                {
                    delete servicio['itinerario']['llegadaADestino'];
                }
                //servicio['itinerario']['finDeServicio'] = servicio['itinerario']['llegadaADestino'];
                //delete servicio['itinerario']['llegadaADestino'];
            }

            // Configura el arreglo de conceptos adicionales si es que el servicio los tiene
            if(servicio.hasOwnProperty('conceptosAdicionales') && servicio['conceptosAdicionales'].length > 0){
                let objetoConceptosAdicionales = {};
                servicio['conceptosAdicionales'].forEach(conceptoAdicional => {
                    let idConceptoAdicional = this.afDB.createPushId();
                    objetoConceptosAdicionales[idConceptoAdicional] = conceptoAdicional;
                });
                servicio['conceptosAdicionales'] = objetoConceptosAdicionales;
            } else
                delete servicio['conceptosAdicionales'];

            // Configura el arreglo de puntos intermedios si es que el servicio los tiene
            if(servicio.hasOwnProperty('puntosIntermedios') && servicio['puntosIntermedios'].length > 0){
                let objetoPuntosIntermedios = {};
                servicio['puntosIntermedios'].forEach(puntoIntermedio => {
                    let idPuntoIntermedio = this.afDB.createPushId();
                    objetoPuntosIntermedios[idPuntoIntermedio] = puntoIntermedio;
                });
                servicio['puntosIntermedios'] = objetoPuntosIntermedios;
            } else
                delete servicio['puntosIntermedios'];

            // Configura los costos de las combinaciones y los precios
           // let objetoCostoCombinaciones = {};
            let objetoPrecioCombinaciones = {};
            servicio['precioCombinaciones'].forEach((combinacion, index) => {
                let idCombinacion = this.afDB.createPushId();
                //objetoCostoCombinaciones[idCombinacion] = combinacion;
                objetoPrecioCombinaciones[idCombinacion] = combinacion;
            });
            servicio['costoCombinaciones'] = {};
            servicio['precioCombinaciones'] = objetoPrecioCombinaciones;

            // Añade el servicio a la cotización
            objServicios[idFirebaseServicio] = servicio;
        });

        return objServicios;
    }

  /**
   * Obtiene los servicios por realizarse 7 días hacia adelante a partir de hoy
   * @param uid Id del usuario/vendedor que está encargado del servicio
   */
  public obtenerProximosServicios(uid?:string){
    let fechaDeHoy = Date.now();
    if(!uid)
      return this.afs.collection('servicios', ref => ref.orderBy('inicioDeServicio','asc').startAt(fechaDeHoy).endAt(fechaDeHoy + (this.diasEnMilis * 7)));
    else
      return this.afs.collection('servicios', ref => ref.orderBy('inicioDeServicio','asc').startAt(fechaDeHoy).endAt(fechaDeHoy + (this.diasEnMilis * 7)));
  }

    public getServiciosPorConfirmacion(arr){

        var info_adicional = {
            conceptosAdicionales:"",
            notas:"",
            indicacionesEspeciales:"",
            notasOperaciones:"",
            puntosIntermedios:[],
        }

        const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

        const body = 'arr=' + arr;

        return this.http.post('https://operacion.trosten.com/corp-school/php/admin/Rutas/getServiciosPorConfirmacion.php', body,{headers});

    }


  /**
   * Obtiene los servicios entre las fechas establecidas de la BD de firebase
   * @param fechaInicial Fecha inicial en timestamp
   * @param fechaFinal Fecha final en timestamp
   */
  public obtenerServiciosEntreFechas(fechaInicial:number, fechaFinal:number){
    return this.afs.collection('servicios', ref => ref.orderBy('inicioDeServicio').startAt(fechaInicial).endAt(fechaFinal));
  }
  public obtenerServiciosEntreFechasCSV(fechaInicial:number, fechaFinal:number){
  return this.afs.firestore.collection('servicios').orderBy('inicioDeServicio').startAt(fechaInicial).endAt(fechaFinal);
}

  /**
   * Obtiene los servicios de una confirmación
   * @param idConfirmacion
   */
  public obtenerServiciosDeConfirmacion(idConfirmacion:string){
    return this.afs.collection('servicios', ref => ref.where('confirmacion','==',idConfirmacion));
  }
  public obtenerServiciosActuales(idConfirmacion:string){
    return this.afs.collection('servicios', ref => ref.where('confirmacion','==',idConfirmacion).where('inicioDeServicio','>',Date.now()));
  }

  /**
   * Obtiene la información de un servicio a través de su ID
   * @param idServicio
   */
  public obtenerServicio(idServicio){
    return this.afs.collection('servicios').doc(idServicio);
  }

  public obtenerServiciosNoAsignados(){
    return this.afs.collection('servicios', ref => ref
    .where('estatus','==','No Asignado')
    .where('inicioDeServicio','>',Date.now())
    .orderBy('inicioDeServicio','asc'));
  }

  public obtenerServiciosNoAsignadosEntreFechas(fechaInicial, fechaFinal){
        return this.afs.collection('servicios', ref => ref
            .where('estatus','==','No Asignado')
            .where('inicioDeServicio','>',fechaInicial)
            .where('inicioDeServicio','<',fechaFinal)
            .orderBy('inicioDeServicio','asc'));
  }

  /**
   * Obtiene la lista de servicios que pertenecen a una plantilla de servicio ligada a una confirmación
   * @param idServicio
   */
  public obtenerServiciosPorPlantillaDeServicio(idServicio:string){
    return this.afs.collection('servicios', ref => ref.where('servicio','==',idServicio));
  }

  /**
   * Obtiene la lista de servicios masivos
   *
   */
  public obtenerServiciosMasivos(){
    return this.afs.collection('confirmaciones', ref => ref.where('asignacionMasivaDeViajes','==',false).where('estatus','==','Confirmada'));
  }

  public editarServiciosMasivos(){
    return this.afs.collection('confirmaciones', ref => ref.where('asignacionMasivaDeViajes','==',true).where('estatus','==','Confirmada'));
  }
  /**
   * Se encarga de verificar el servicio por parte del departamento de ventas
   * @param idServicio
   */
  public verificarServicioVentas(idServicio){
    return this.afs.collection('servicios').doc(idServicio).update({ verificacionVentas : true });
  }

    public desverificarServicioVentas(idServicio){
        return this.afs.collection('servicios').doc(idServicio).update({ verificacionVentas : false });
    }

    public verificarServicioOperaciones(idServicio){
        return this.afs.collection('servicios').doc(idServicio).update({ verificacionOperaciones: true, verificacionOperacionesAt: new Date() });
    }

    public desverificarServicioOperaciones(idServicio){
        return this.afs.collection('servicios').doc(idServicio).update({ verificacionOperaciones: false, verificacionOperacionesAt: null });
    }

  public editarFechasServicio(idServicio:string,inicio,fin,notas,llegada_destino,regreso_origen){
      //console.log("EditarFechasServicio",idServicio,inicio,fin)
      return this.afs.collection('servicios').doc(idServicio).update({inicioDeServicio:inicio,finDeServicio:fin,notas:notas,llegadaADestino:llegada_destino,regresoAOrigen:regreso_origen});
      /*return this.afs.collection("servicios")
          .doc(idServicio)
          .ref
          .get().then(function(doc) {
          if (doc.exists) {
              console.log("Document data:", doc.data());
          } else {
              console.log("No such document!");
          }
      }).catch(function(error) {
          console.log("Error getting document:", error);
      });
*/
  }


  public serviciosPosibles(){
      return this.afs.collection('servicios', ref => ref.where('estatus','==','Posible').where('inicioDeServicio','>',Date.now()));
  }

    /**
     * Convierte todos los elementos dentro del nodo de servicios de una cotización
     * en arreglos para poder ser manipulados de una mejor manera y puedan ser editados y mostrados fácilmente
     * @param servicios recibe el objeto de servicios justamente como viene de las cotizaciones
     * @param conFirebaseKeys indica si el usuario quiere que se incluyan los FB keys en el objeto
     */
    public convertirServiciosArreglos(servicios:any, conFirebaseKeys:boolean = false) : Array<any>{
        let arrServicios = [];

        // Recorre y agrega los servicios, coloca su id dentro del objeto
        for (let idServicio in servicios) {
            let objServicio = servicios[idServicio];
            if (conFirebaseKeys) {
                objServicio['$key'] = idServicio;
            }

            // Recorre y agrega los conceptos adicionales que existan
            let arrConceptosAdicionales = [];
            for (let idConceptoAdicional in objServicio['conceptosAdicionales']) {
                let objConcepto = objServicio.conceptosAdicionales[idConceptoAdicional];
                if (conFirebaseKeys) {
                    objConcepto['$key'] = idConceptoAdicional;
                }
                arrConceptosAdicionales.push(objConcepto);
            }
            objServicio.conceptosAdicionales = arrConceptosAdicionales;

            // Recorre y agrega los precios de las combinaciones que existen
            let arrPrecioCombinaciones = [];
            for (let idPrecioCombinacion in objServicio['precioCombinaciones']) {
                let objPrecioCombinacion = {
                    precio : objServicio.precioCombinaciones[idPrecioCombinacion]
                };
                if (conFirebaseKeys) {
                    objPrecioCombinacion['$key'] = idPrecioCombinacion;
                }
                arrPrecioCombinaciones.push(objPrecioCombinacion);
            }
            objServicio.precioCombinaciones = arrPrecioCombinaciones;

            // Recorre y agrega los puntos intermedios que existen
            let arrPuntosIntermedios = [];
            for (let idPuntoIntermedio in objServicio['puntosIntermedios']) {
                let objPuntoIntermedio = objServicio.puntosIntermedios[idPuntoIntermedio];
                if (conFirebaseKeys) {
                    objPuntoIntermedio['$key'] = idPuntoIntermedio;
                }
                arrPuntosIntermedios.push(objPuntoIntermedio);
            }
            objServicio.puntosIntermedios = arrPuntosIntermedios;

            // Recorre los costos de las combinaciones que existen en el objeto
            let arrCostoCombinaciones = [];
            for (let idCostoCombinacion in objServicio['costoCombinaciones']) {
                let objCostoCombinacion = objServicio.costoCombinaciones[idCostoCombinacion];

                // Recorre los tipos de unidades que se solicitaron
                let arrTiposDeUnidad = [];
                for (let tipoDeUnidad in objCostoCombinacion) {
                    let objTipoDeUnidad = objCostoCombinacion[tipoDeUnidad];
                    objTipoDeUnidad['tipoDeUnidad'] = tipoDeUnidad;
                    arrTiposDeUnidad.push(objTipoDeUnidad);
                }
                objCostoCombinacion = {
                    tiposDeUnidad : arrTiposDeUnidad
                };
                if (conFirebaseKeys) {
                    objCostoCombinacion['$key'] = idCostoCombinacion;
                }

                arrCostoCombinaciones.push(objCostoCombinacion);
            }
            objServicio.costoCombinaciones = arrCostoCombinaciones;

            // Agrega el servicio al arreglo
            arrServicios.push(objServicio);
        }

        return arrServicios;
    }

    /**
     * Valida que los objetos de origen y destino tengan dirección y coordenadas
     * @param servicio
     */
    public validarOrigenYDestino(servicio:any):boolean {
        let sonValidos = true;
        if(
            servicio.origen.direccion.trim().length == 0        ||
            servicio.destino.direccion.trim().length == 0       ||
            servicio.origen.alias == null                       ||
            servicio.destino.alias == null                      ||
            servicio.origen.alias == undefined                  ||
            servicio.destino.alias == undefined                 ||
            servicio.origen.alias.trim().length == 0            ||
            servicio.destino.alias.trim().length == 0           ||
            !servicio.origen.hasOwnProperty('coordenadas')      ||
            servicio.origen.coordenadas == null                 ||
            servicio.origen.coordenadas == undefined            ||
            !servicio.destino.hasOwnProperty('coordenadas')     ||
            servicio.destino.coordenadas == null                ||
            servicio.destino.coordenadas == undefined
        ) {
            sonValidos = false;
            alert('Error: el origen y/o destino no tienen la dirección, las corrdenadas o el alias');
        }
        return sonValidos;
    }

    /**
     * Valida que los puntos intermedios tengan coordenadas y dirección
     * @param servicio
     */
    public validarPuntosIntermedios(servicio:any):boolean {
        let sonValidos = true;
        for (let i = 0; i < servicio.puntosIntermedios.length; i++) {
            let pi = servicio.puntosIntermedios[i];
            if(
                !pi.hasOwnProperty('coordenadas')   ||
                !pi.hasOwnProperty('direccion')     ||
                pi.coordenadas == null              ||
                pi.coordenadas == undefined         ||
                pi.direccion == null                ||
                pi.direccion == undefined
            ) {
                sonValidos = false;
                alert('Existe un problema con los puntos intermedios que ingresaste');
                break;
            }
        }
        return sonValidos;
    }

    /**
     * Valida que el itinerario del servicio tenga los 4 horarios
     * @param servicio
     */
    public validarItinerario(servicio:any):boolean {
        let esValido = true;
        let itinerario = servicio.itinerario;
        console.log("Servicio a Revisar",servicio);
        debugger
        if(
            !itinerario.hasOwnProperty('inicioDeServicio')  ||
            (
                !itinerario.hasOwnProperty('llegadaADestino') && servicio.tipoDeViaje=="Viaje Redondo"
            )
                                                                ||
            !itinerario.hasOwnProperty('regresoAOrigen')    ||
            !itinerario.hasOwnProperty('finDeServicio')     ||
            itinerario.inicioDeServicio == null             ||
            itinerario.inicioDeServicio == undefined        ||
            isNaN(itinerario.inicioDeServicio)              ||

            (
                servicio.tipoDeViaje=="Viaje Redondo" &&
                (
                itinerario.llegadaADestino == null              ||
                itinerario.llegadaADestino == undefined         ||
                isNaN(itinerario.llegadaADestino)
                )
            )
                                                            ||
            itinerario.regresoAOrigen == null               ||
            itinerario.regresoAOrigen == undefined          ||
            isNaN(itinerario.regresoAOrigen)                ||
            itinerario.finDeServicio == null                ||
            itinerario.finDeServicio == undefined           ||
            isNaN(itinerario.finDeServicio)                 ||
            itinerario.inicioDeServicio >= itinerario.finDeServicio
        ) {
            esValido = false;
            alert('Asegúrate que el servicio cuente con fecha y hora de inicio y fin válidos');
        }
        return esValido;
    }

    /**
     * Valida distintos parámetros misc del servicio
     * @param servicio
     */
    public validarParametros(servicio:any):boolean {
        let parametros = servicio.parametros;

        if(servicio.oficinaDeOrigen == null || servicio.oficinaDeOrigen == undefined) {
            alert('Por favor selecciona una oficina de origen');
            return false;
        }

        if(servicio.tipoDeViaje == null || servicio.tipoDeViaje == undefined) {
            alert('Por favor selecciona un tipo de viaje');
            return false;
        }

        if(isNaN(parametros.repeticionesDelServicio) || parametros.repeticionesDelServicio == null || parametros.repeticionesDelServicio == undefined || parametros.repeticionesDelServicio < 1) {
            alert('Las repeticiones del servicio deben ser por lo menos 1');
            return false;
        }

        if(isNaN(parametros.cantidadDeOperadores) || parametros.cantidadDeOperadores == null || parametros.cantidadDeOperadores == undefined || parametros.cantidadDeOperadores < 1 || parametros.cantidadDeOperadores > 2) {
            alert('La cantidad de operadores sòlo puede ser 1 ó 2');
            return false;
        }

        if(isNaN(parametros.cantidadDePasajeros) || parametros.cantidadDePasajeros == null || parametros.cantidadDePasajeros == undefined || parametros.cantidadDePasajeros < 1) {
            alert('La cantidad de pasajeros debe de ser mayor a cero');
            return false;
        }

        if(isNaN(parametros.costoDeCasetas) || parametros.costoDeCasetas == null || parametros.costoDeCasetas == undefined || parametros.costoDeCasetas < 0) {
            alert('El costo de las casetas debe ser mayor o igual a cero');
            return false;
        }

        if(isNaN(parametros.nochesDeHospedaje) || parametros.nochesDeHospedaje == null || parametros.nochesDeHospedaje == undefined || parametros.nochesDeHospedaje < 0) {
            alert('Las noches de hospedaje deben ser mayor o igual a cero');
            return false;
        }

        if(isNaN(parametros.kilometrosDeEstadia) || parametros.kilometrosDeEstadia == null || parametros.kilometrosDeEstadia == undefined || parametros.kilometrosDeEstadia < 0) {
            alert('Los kilómetros de estadía deben ser mayor o igual a cero');
            return false;
        }

        return true;
    }
    // Obtener objeto y regresa cliente
   public obtenerPropiedadServicio(idServicio, propiedad){
        return this.afs.collection('servicios').doc(idServicio).valueChanges().map(res=>{
            return res[propiedad]
        })
    }
    public generarNotaCambioServicio(objeto){
        return this.afs.collection('notasDeCambioServicio').add(objeto)
    }

    public obtenerNotaCambioServicio(id){
        /*this.afs.collection(`servicios`,
            ref => ref.where('tipoDeVenta','==','Corporativo')).valueChanges().subscribe(servicios => {
            servicios.map((servicio) => {
                console.log(servicio.payload.doc.id)
                // this.afs.doc(`tests/${this.testID}/servicios/${servicio.id}`).delete()
                //     .catch(error => {console.log(error); })
                //     .then(() => console.log(`Deleting question (${question.id}) in (${this.testID})`));
            });
        });*/
        return this.afs.collection('notasDeCambioServicio', ref => ref
            .where('servicio', '==', id));
    }

    public obtenerServiciosCorporativos(){
        /*this.afs.collection(`servicios`,
            ref => ref.where('tipoDeVenta','==','Corporativo')).valueChanges().subscribe(servicios => {
            servicios.map((servicio) => {
                console.log(servicio.payload.doc.id)
                // this.afs.doc(`tests/${this.testID}/servicios/${servicio.id}`).delete()
                //     .catch(error => {console.log(error); })
                //     .then(() => console.log(`Deleting question (${question.id}) in (${this.testID})`));
            });
        });*/
        return this.afs.collection('servicios', ref => ref
            .where('tipoDeVenta', '==', 'Turístico')
            .where('cliente','==','-LmAfgdXlbOivTqqUrrT'));
    }

    public eliminarServicioCorporativo(uid)
    {
        this.afs.collection("servicios").doc(uid).delete().then(function() {
            console.log(uid+ "Document successfully deleted!");
        }).catch(function(error) {
            console.error("Error removing document: "+uid, error);
        });
    }

    public actualizarIdTrosten (nuevoIdTrosten,idServicio)
    {
        return this.afs.collection('servicios').doc(idServicio).update({
            idConfirmacion : nuevoIdTrosten
        });
    }

    public actualizarConceptosAdicionales (idServicio,conceptosAdicionales)
    {
        return this.afs.collection('servicios').doc(idServicio).update({
            conceptosAdicionales : conceptosAdicionales
        });
    }

    public subirEspecificacion(file: File, idTrosten: string) {
        const formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('idTrosten', idTrosten);
        return this.http.post<any>(
            'https://operacion.trosten.com/corp-school/php/admin/Documentos/subirEspecificacionesDoc.php',
            formData
        );
    }

    public actualizarEspecificaciones(idServicio: string, especificaciones: any[]) {
        return this.afs.collection('servicios').doc(idServicio).update({ especificaciones });
    }

    public actualizarEspecificacionesHabilitadas(idServicio: string, habilitadas: boolean) {
        return this.afs.collection('servicios').doc(idServicio).update({ especificacionesHabilitadas: habilitadas });
    }
    
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/servicios.service.ts